import React from 'react'

export const Offerings = [
  {
    name: 'Listagem de Ofertas',
    component: React.lazy(() => import('../../modules/coordinator/offerings/list')),
    path: '/coordinator/offerings',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged', 'allowOfferings'],
  },
  {
    name: 'Tipo de Ofertas',
    component: React.lazy(() => import('../../modules/coordinator/offerings/offeringsType')),
    path: '/coordinator/offerings/type',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged', 'allowOfferings'],
  },
  {
    name: 'Ofertas',
    component: React.lazy(() => import('../../modules/coordinator/offerings/schedule')),
    path: '/coordinator/offerings/schedule',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged', 'allowOfferings'],
  },
  {
    name: 'Ofertas',
    component: React.lazy(() => import('../../modules/coordinator/offerings/schedule')),
    path: '/coordinator/offerings/schedule/:offeringId',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged', 'allowOfferings'],
  },
  {
    name: 'Criação de Oferta',
    component: React.lazy(() => import('../../modules/coordinator/offerings/create')),
    path: '/coordinator/offerings/create',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged', 'allowOfferings'],
  },
  {
    name: 'Edição de Oferta',
    component: React.lazy(() => import('../../modules/coordinator/offerings/create')),
    path: '/coordinator/offerings/:offeringId',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged', 'allowOfferings'],
  },
]
